import { NotificationButton } from '@avanta/shared/components/chat/NotificationButton';
import { Card } from '@avanta/shared/components/ui/Card';
import { cn } from '@avanta/shared/utils/cn';
import { type PropsWithChildren } from 'react';
import { type BannerProps } from './types';

export const Banner = ({
  title,
  icon: Icon,
  description,
  image,
  buttonProps,
  className,
  children,
}: PropsWithChildren<BannerProps>): React.ReactElement => (
  <Card className={cn('bg-teal-100 p-0', className)}>
    {image && <img src={image} alt={title} className="w-full object-cover rounded-t-xl" />}
    <div className="flex flex-col p-4 gap-4">
      <div className="flex gap-2">
        {Icon && <Icon className="size-6 am-md:size-8 shrink-0 text-teal-600" />}
        <div className="flex flex-col gap-1 flex-1">
          {title && <h2 className="text-md am-md:text-lg font-semibold text-denim-600">{title}</h2>}
          {description && <p className="text-xs am-lg:h-11 h-fit text-gray-600">{description}</p>}
        </div>
      </div>
      {children}
      {buttonProps && (
        <NotificationButton size="lg" className="w-full" {...buttonProps}>
          {buttonProps.label}
        </NotificationButton>
      )}
    </div>
  </Card>
);
